import { INDUSTRIES } from "@/data/industries";
import { SectionHeader, Reveal } from "@/components/SectionHeader";
import SEO from "@/components/SEO";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <SEO
        title="Industries Served — Homeowners, Schools, Healthcare, Commercial"
        description="Independent environmental consulting trusted by homeowners, commercial owners, schools, healthcare, attorneys, insurance carriers, restoration contractors, realtors, and government agencies."
        path="/industries"
      />
      <section className="bg-[#F8FAFC] py-24">
        <div className="container-x">
          <div className="overline mb-5">Industries served</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-[#0F172A] leading-[1.05] max-w-4xl">
            One scientific standard. Every industry that depends on it.
          </h1>
        </div>
      </section>
      <section className="section-pad bg-white">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <Reveal key={ind.name} delay={i * 0.04}>
                <div data-testid={`industry-${i}`} className="card-soft p-8 h-full">
                  <div className="w-12 h-12 rounded-xl bg-[#7C3AED]/10 grid place-items-center mb-5">
                    <Icon className="w-6 h-6 text-[#7C3AED]" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-[#0F172A]">{ind.name}</h3>
                  <p className="text-sm text-slate-600 mt-3 leading-relaxed">{ind.blurb}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
